import React, { useState } from 'react';
import './BstId.css';

/*
 * BstId — the human-readable task identifier (WR-013 §4).
 *
 * Rendered in JetBrains Mono, which is one of the four sanctioned mono uses
 * (§3: ids, dates, counts, status codes).
 *
 * `copyable` turns it into a click-to-copy control; that is used in the task
 * modal, where someone is likely to want the id to paste into a message. On
 * cards it is plain text — a card is already a click target for opening the
 * task, and a nested button there would fight it.
 */
function BstId({ id, copyable = false, className = '' }) {
  const [copied, setCopied] = useState(false);
  if (!id) return null;

  if (!copyable) {
    return <span className={`bst-id ${className}`.trim()}>{id}</span>;
  }

  const copy = async (e) => {
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(id);
      setCopied(true);
      setTimeout(() => setCopied(false), 1400);
    } catch {
      // Clipboard blocked (permissions, insecure origin). The id is on
      // screen and selectable, so this degrades to "select it yourself".
    }
  };

  return (
    <button
      type="button"
      className={`bst-id bst-id-copy ${className}`.trim()}
      onClick={copy}
      title={copied ? 'Copied' : `Copy ${id}`}
      aria-label={`Copy task id ${id}`}
    >
      {copied ? 'Copied' : id}
    </button>
  );
}

export default BstId;
